import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export interface NotificationTemplate {
  id: string;
  template_key: string;
  title_template: string;
  body_template: string;
  emoji: string;
  description: string | null;
  available_placeholders: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function useNotificationTemplates() {
  const [templates, setTemplates] = useState<NotificationTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const fetchTemplates = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('notification_templates')
      .select('*')
      .order('template_key');

    if (error) {
      console.error('Error fetching templates:', error);
      toast({
        title: 'Fout bij laden templates',
        description: error.message,
        variant: 'destructive',
      });
    } else {
      setTemplates(data || []);
    }
    setLoading(false);
  };

  const updateTemplate = async (
    id: string,
    updates: Partial<Pick<NotificationTemplate, 'title_template' | 'body_template' | 'emoji' | 'is_active'>>
  ) => {
    const { error } = await supabase
      .from('notification_templates')
      .update(updates)
      .eq('id', id);

    if (error) {
      toast({
        title: 'Fout bij opslaan',
        description: error.message,
        variant: 'destructive',
      });
      return false;
    }

    toast({
      title: 'Template opgeslagen',
      description: 'De wijzigingen zijn opgeslagen.',
    });
    
    await fetchTemplates();
    return true;
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return {
    templates,
    loading,
    refetch: fetchTemplates,
    updateTemplate,
  };
}
